import React from 'react'
import GoogleMapReact from 'google-map-react'
import PropTypes from 'prop-types'

const SearchMap = ({
  center = [-23.550421, -46.633468],
  zoom = 13,
  maxZoom = 20,
  children,
  useMapsApi,
  onChange,
  streetViewControl,
  onGoogleApiLoaded,
}) => {
  return (
    <GoogleMapReact
      bootstrapURLKeys={{
        libraries: ['drawing', 'geometry'],
        key: process.env.REACT_APP_GOOGLE_MAP_KEY,
        region: 'BR',
        language: 'pt-BR',
      }}
      onChange={onChange}
      yesIWantToUseGoogleMapApiInternals={useMapsApi}
      onGoogleApiLoaded={onGoogleApiLoaded}
      center={center}
      zoom={zoom}
      rotateControl={false}
      resetBoundsOnResize
      options={{
        clickableIcons: false,
        gestureHandling: 'greedy',
        maxZoom,
        streetViewControl,
      }}
    >
      {children}
    </GoogleMapReact>
  )
}

SearchMap.propTypes = {
  className: PropTypes.string,
  defaultCenter: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.object,
  ]),
  defaultZoom: PropTypes.number,
  center: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.object,
  ]),
  zoom: PropTypes.number,
}

SearchMap.defaultProps = {
  defaultCenter: [-24.955278, -53.464267],
  defaultZoom: 13,
  center: [-24.955278, -53.464267],
  zoom: 13,
}

export default SearchMap
